module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3_jp.b6c94f9a435ebd8fffedc25568977ea1.png";